<div class="body-login">
  <div class=""></div>
  <!-- <iframe
    title="application"
    style="height: 2px; width: 2px"
    #iframe
    [src]="this.iframeSrc"
    (load)="onLoad(iframe)"
  ></iframe> -->
  <div class="container">
    <div class="login-container">
      <dx-form
        [(formData)]="user"
        [readOnly]="false"
        [showColonAfterLabel]="true"
        [showValidationSummary]="true"
        validationGroup="customerData"
      >
        <dxi-item itemType="group">
          <dxi-item>
            <div *dxTemplate class="mt-2 text-center">
              <img
                width="140"
                src="../../../../assets/icons/LogoQuiron.svg"
                alt="icon"
              />
              <h2>Iniciar sesión</h2>
            </div>
          </dxi-item>

          <dxi-item
            cssClass="mt-4 ml-4 mr-4"
            dataField="usuario"
            [editorOptions]="{ stylingMode: 'underlined', inputAttr: {'style': 'text-transform: uppercase'},  onEnterKey: onEnterKeyUsuario, placeholder: 'Usuario' }"
          >
            <dxo-label
              text="Usuario"
              location="top"
              [visible]="false"
            ></dxo-label>
            <dxi-validation-rule
              type="required"
              message="Usuario es requerido"
            ></dxi-validation-rule>
          </dxi-item>

          <dxi-item
            cssClass="mt-4 mb-2 ml-4 mr-4"
            dataField="password"
            [editorOptions]="{ mode: 'password', stylingMode: 'underlined',onEnterKey: onEnterKeyPassword, placeholder: 'Contraseña'}"
          >
            <dxo-label
              text="Contraseña"
              location="top"
              [visible]="false"
            ></dxo-label>
            <dxi-validation-rule
              type="required"
              message="Contraseña es requerida"
            ></dxi-validation-rule>
          </dxi-item>
        </dxi-item>
        <dxi-item>
          <div *dxTemplate class="mt-1 text-center">
            <a class="olvido-text" routerLink="/forgot-password"
              >¿Ha olvidado su contraseña?
            </a>
          </div>
        </dxi-item>

        <dxi-item itemType="group" cssClass="mt-4">
          <dxi-item
            itemType="button"
            horizontalAlignment="center"
            [buttonOptions]="{
        type: 'default',
        text: 'Ingresar',
        width: '60%',
        height: 50,
        onClick: onSubmit
      }"
          >
          </dxi-item>
        </dxi-item>
      </dx-form>
    </div>
  </div>
</div>

<dx-load-panel
  shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
>
</dx-load-panel>
